var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('input',{staticClass:"controls form-control w-75",attrs:{"id":"pac-input","type":"hidden","placeholder":_vm.trans.get('common.search')}}),_vm._v(" "),_c('div',{staticClass:"min-h-50",staticStyle:{"width":"100%"},attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }